import React from 'react';
import { XCircle, Unlock } from 'lucide-react';
import { FadeIn } from './FadeIn';
const failures = ["Ser 'tú misma' (sin estrategia)", "Ignorar mensajes para 'hacerte la difícil'", 'Copiar consejos genéricos de TikTok', 'Enviar mensajes largos y sinceros', 'Ser demasiado fría y distante'];
export function FailedSolutions() {
  return <section className="py-14 px-6 relative bg-[#0a0a0a]" data-id="element-84">
      <div className="max-w-4xl mx-auto text-center" data-id="element-85">
        <FadeIn data-id="element-86">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8" data-id="element-87">
            Por qué otras soluciones{' '}
            <span className="text-brand-rose italic" data-id="element-88">fallan</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 items-center text-left" data-id="element-89">
          <FadeIn direction="left" data-id="element-90">
            <div className="space-y-4" data-id="element-91">
              <p className="text-brand-lightGray text-lg mb-4" data-id="element-92">
                Seguramente ya has intentado:
              </p>
              <ul className="space-y-3" data-id="element-93">
                {failures.map((item, i) => <li key={i} className="flex items-center gap-3 text-brand-cream/80" data-id="element-94">
                    <XCircle className="w-5 h-5 text-red-500/70" data-id="element-95" />
                    <span data-id="element-96">{item}</span>
                  </li>)}
              </ul>
              <p className="text-brand-rose font-medium mt-4 text-lg" data-id="element-97">
                ¿Resultado? Nada consistente.
              </p>
            </div>
          </FadeIn>

          <FadeIn direction="right" data-id="element-98">
            <div className="bg-brand-gray/40 p-6 rounded-3xl border border-white/5 relative overflow-hidden" data-id="element-99">
              <Unlock className="absolute -right-4 -bottom-4 w-32 h-32 text-white/5" data-id="element-100" />
              <h3 className="text-xl font-semibold mb-3 text-brand-cream" data-id="element-101">
                Porque son tácticas superficiales
              </h3>
              <ul className="space-y-2 text-brand-lightGray mb-6" data-id="element-102">
                <li data-id="element-103">• No entienden la psicología masculina</li>
                <li data-id="element-104">• No consideran el contexto emocional</li>
                <li data-id="element-105">• Son genéricas, no estratégicas</li>
              </ul>
              <div className="p-3 bg-brand-dark rounded-xl border border-brand-rose/20" data-id="element-106">
                <p className="text-brand-cream italic text-sm" data-id="element-107">
                  "Es como intentar abrir una caja fuerte… sin conocer la
                  combinación."
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}